module.exports = __webpack_public_path__ + "img/headImg.88310ace.png";